import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import { useIntl } from "react-intl";
import QRCodeGenerator from "qrcode";

import { common } from "../messages";

export default function QRCodeDialogGeneric({
  code,
  doClose,
  open,
  title,
  showCode,
}) {
  const intl = useIntl();

  const [qrSrc, setQrSrc] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const handleClose = useCallback(
    (e) => {
      if (e) e.stopPropagation();

      setQrSrc("");
      setError(false);
      setLoading(false);

      doClose();
    },
    [doClose]
  );

  useEffect(() => {
    let active = true;

    if (!open || !code) {
      setQrSrc("");
      setError(false);
      setLoading(false);
      return undefined;
    }

    setLoading(true);
    setError(false);

    QRCodeGenerator.toDataURL(code, {
      errorCorrectionLevel: "M",
      margin: 2,
      width: 256,
    })
      .then((dataUrl) => {
        if (!active) return;
        setQrSrc(dataUrl);
      })
      .catch(() => {
        if (!active) return;
        setQrSrc("");
        setError(true);
      })
      .finally(() => {
        if (!active) return;
        setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [open, code]);

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title || "QR Code"}</DialogTitle>

      <DialogContent align="center">
        {showCode && <Typography>{code}</Typography>}
        {loading && <CircularProgress />}

        {!loading && error && (
          <Typography color="error">
            Errore durante la generazione del QR Code.
          </Typography>
        )}

        {!loading && !error && qrSrc && (
          <img
            src={qrSrc}
            alt="QR Code"
            style={{
              display: "block",
              margin: "0 auto",
              maxWidth: "100%",
              width: 400,
              height: 400,
            }}
          />
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} variant="contained" color="primary">
          {intl.formatMessage(common.close)}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
